import { Injectable } from '@angular/core';
import { filterNilValue, QueryEntity } from '@datorama/akita';
import { DropboxState } from './dropbox.model';
import { DropboxStore } from './dropbox.store';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DropboxQuery extends QueryEntity<DropboxState> {
    connectState$ = this.select('connectState');
    get basePath(): string {
        return this.getValue().basePath;
    }
    basePath$ = this.select('basePath').pipe(filterNilValue());

    constructor(protected store: DropboxStore) {
        super(store);
    }

    selectFilesInFolder$(folder: string) {
        return this.selectAll({
            filterBy: (entity) => entity.folder === folder
        });
    }

    connected$ = this.select('refreshToken').pipe(map((refreshToken) => !!refreshToken));
    tokens$ = this.select(['refreshToken', 'accessToken']);
}
